import React from 'react';
import PropTypes from 'prop-types';

import proNotifications from '../../../../modules/proNotifications';
import analytics from '../../../../modules/analytics';
import useMount from '../../../../hooks/useMount';

import { NewClientDeliveryDisplayUI } from '../../newClientDelivery/NewClientDeliveryDisplay';

export default function NewClientDeliveryNotification({ notification }) {
  const {
    appointment_id: appointmentId,
    provider_id: providerId,
    client_name: clientName,
    client_thumbnail: clientThumbnail,
    service_name: serviceName,
    ncd_fee_percent: ncdFeePercent,
    local_start: localStart,
    responses,
  } = notification;

  const clickTracking = {
    name: proNotifications.NOTIFICATION_CLICKED_EVENT,
    params: proNotifications.createNotificationParams(notification),
  };

  useMount(() => {
    // fire tracking event when component mounts
    analytics.track('ncd_insights_notification_viewed', {
      providerId,
      appointment_id: appointmentId,
    });
  });

  return (
    <NewClientDeliveryDisplayUI
      appointmentId={appointmentId}
      clientName={clientName}
      clientThumbnail={clientThumbnail}
      serviceName={serviceName}
      ncdFeePercent={ncdFeePercent}
      responses={responses}
      localStart={localStart}
      clickTracking={clickTracking}
      appearance="notification"
    />
  );
}

NewClientDeliveryNotification.propTypes = {
  /** The notification object */
  notification: PropTypes.object.isRequired,
};
